import {
  AxisSwitcher,
  Col,
  H2,
  P,
  ProductTile,
  Row,
  Section,
  SpacerWrapper,
  TypeWrapper,
  Wrapper,
} from '@ahmdigital/ui';
import { concat, filter, flow, get, includes, map, omit, size } from 'lodash/fp';
import React from 'react';

import constants from '../../../../../../../ahm-constants';
import filterProducts from './utils/filter-products';
import getIsNoGapDentalProduct from '../../../../../../../features/no-gap-dental/utils/get-is-no-gap-dental-product';
import prepareProductForProductTile from '../../../../../../../utils/prepare-product-for-product-tile';
import PriceDisclaimer from '../../../../../../../components/price-disclaimer';
import SegmentationBar from '../../../../../../../components/segmentation-bar';
import StateDentistLogo from '../state-dentist-logo';
import styles from './styles.module.sass';

const smallThreshold = '44rem';
const {
  URLS: {
    SALES: { CHOOSABLE_PICKER },
  },
} = constants;

const choosableProductTileContent = {
  content: {
    longForm:
      'With our new choosable extras, simply start with our base bundle of teeth and emergency ambulance, then choose the extras bundles that you’ll actually use.',
  },
  name: 'choosable extras',
  url: CHOOSABLE_PICKER,
};

type ProductsProps = {
  customer?: {
    frequency?: string;
    productType: unknown[];
    state: unknown[];
  };
  isLoadingPrice?: boolean;
  isProductWithHospitalServices: boolean;
  prices?: {};
  productTypes: unknown[][];
  products?: {};
  useFutureEffectiveDate?: boolean;
};

const Products = ({
  customer,
  isLoadingPrice,
  isProductWithHospitalServices,
  prices,
  productTypes,
  products,
  useFutureEffectiveDate,
}: ProductsProps) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { productType } = customer;
  if (!includes(productType, productTypes)) {
    return null;
  }
  const filteredProducts = filterProducts({ productType, products });

  const productTileProducts = flow(
    // @ts-expect-error - Automatic, Please fix when editing this file
    map(prepareProductForProductTile({ customer, frequency: customer.frequency, prices, useFutureEffectiveDate })),
    // @ts-expect-error - Automatic, Please fix when editing this file
    filter((product) => getIsNoGapDentalProduct({ product, state: customer.state })),
  )(filteredProducts);

  const productTileProductsProcessed = !isProductWithHospitalServices
    ? concat(choosableProductTileContent, productTileProducts)
    : productTileProducts;

  const amountOfProducts = size(productTileProductsProcessed);

  return (
    <Section>
      <Wrapper>
        <Row>
          <Col df={12}>
            <H2 variant={['center', 'marginBottomSpacer9']}>Choose from the below cover options</H2>
          </Col>
        </Row>
        <Row>
          <Col df={12} variant="marginBottomSpacer9">
            <P variant="center">These products include no gap dental check-ups at select dentists^</P>
          </Col>
        </Row>
        <Row>
          <Col df={12} variant={['marginBottomSpacer7']}>
            <SegmentationBar productTypes={productTypes} />
          </Col>
        </Row>
        <SpacerWrapper variant={['marginBottomSpacer7', styles.axisSwitcherWrapper]}>
          <AxisSwitcher limit={amountOfProducts} space="1rem" threshold={smallThreshold}>
            {map(
              (product) => (
                // @ts-expect-error - Automatic, Please fix when editing this file
                <div className={styles.productTileWrapper} key={product.url}>
                  {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ isLoadingPrice: boolean | undefined; key: any; linkTo: any; blurb: any; variant: string | undefined; showPrice: boolean; }' is missing the following properties from type 'Pick<Pick<ProductTileProps, keyof ProductTileProps> & Pick<InferProps<{ ctaVariant: Requireable<NonNullable<string | object | null | undefined>>; variant: Requireable<...>; }>, "ctaVariant"> & Pick<...>, "name" | ... 3 more ... | "ctavariant">': name, type, id, frequency */}
                  <ProductTile
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    {...omit(['url', 'content'], product)}
                    isLoadingPrice={isLoadingPrice}
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    key={product.url}
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    linkTo={product.url}
                    blurb={get('content.longForm', product)}
                    variant={styles.productTile}
                    showPrice={isLoadingPrice || get('price', product) !== undefined}
                  />
                </div>
              ),
              productTileProductsProcessed,
            )}
          </AxisSwitcher>
        </SpacerWrapper>
        <Row>
          <Col df={12}>
            <PriceDisclaimer bold forProducts={filteredProducts} highlightIncome showRefineLink center constrainWidth />
          </Col>
        </Row>
        <div className={styles.footnote}>^Excludes specialists</div>
        <Row>
          <Col df={12}>
            <TypeWrapper variant={['center']}>
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <StateDentistLogo state={customer.state} />
            </TypeWrapper>
          </Col>
        </Row>
      </Wrapper>
    </Section>
  );
};

Products.defaultProps = {
  customer: null,
  isLoadingPrice: false,
  prices: null,
  products: null,
  useFutureEffectiveDate: false,
};

export default Products;
